import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import recordIcon from '../../fsa-style/img/svgs/record_grey.svg';
import recordIconWhite from '../../fsa-style/img/svgs/record_white.svg';
import scanIcon from '../../fsa-style/img/svgs/scan_grey.svg';
import scanIconWhite from '../../fsa-style/img/svgs/scan_white.svg';
import magnifyingGlassWhite from '../../fsa-style/img/svgs/magnifying-glass.svg';
import magnifyingGlassGrey from '../../fsa-style/img/svgs/magnifying-glass-grey.svg';
import buowIcon from '../../fsa-style/img/svgs/buow_white.svg';
import Administrator from '../../fsa-style/img/svgs/admin_blue.svg';
import houseGrey from '../../fsa-style/img/svgs/house.svg';
import houseWhite from '../../fsa-style/img/svgs/house-white.svg';

import AdministratorIconWhite from '../../fsa-style/img/svgs/admin_white.svg';
import dashboardIcon from '../../fsa-style/img/svgs/dashboard_grey.svg';
import dashboardIconWhite from '../../fsa-style/img/svgs/dashboard_white.svg';
import './SideNavBar.scss';
import UserContext from '../UserContext/UserContext';
import FetchLocalStorageDataByPath from '../../utils/helper/FetchLocalstorageDataByPath';
import { EventEmitter } from '../../services/events';
import { buowLockLooper } from '../../services/inBasketService';
const SideNavBar = ({ logout }) => {
  const [selectedLink, isLinkSelected] = useState('/');
  const [showPopup, setPopupVal] = useState(false);
  const userRole = JSON.parse(sessionStorage.getItem('permissions'));
  const [isFeatureActive, setisFeatureActive] = useState({});
  const navigateTo = useNavigate();

  const adminPanelRoutes = [
    'admin',
    'orchestration',
    'routingsteps',
    'systemconfiguration',
    'ruledefinition',
    'userstable',
    'rolestable',
    'permissionstable',
    'user-preference',
    'system-folder',
    'buowtable',
    'userguide',
    'work-group',
    'messages',
    'inbaskettable',
    'buowdisplayname',
    'work-group',
    'unit-of-work',
    'workgroupuserxwalk',
    'rule-log',
    'ruletrigger',
    'object-hierarchy-table',
    'elements',
    'element-group',
    'redactionhistorytable',
    'redaction-reference',
    'objectdefinition',
    'redaction-actor',
    'objectdictionaryobject',
    'redaction-reason',
    'objectdictionaryobjecttype',
    'redactiondefinition',
    'routingconditions',
    'batchdefinition',
    'packager-preferred-order',
    'packager-configuration',
    'batch-xwalk',
    'objectdefinitiontable',
    'dashboard-indicator',
    'dashboard-indicators-dataSet-card-xref',
    'sec-role-dashboard-card-xref',
    'dashboard-group-card-xref',
    'dashboard-indicators-group',
    'dashboard-card-benchmark-display',
    'indicators-data-set',
    'elementgroupxwalk',
    'emailtemplate',
    'ruletriggermetadata',
    'redaction-configuration',
    'roleworkgroupxwalk',
    'buoweligibilitycriteria',
    "object-template"
  ];

  const visibilityRoutes = ['dashboard', 'search', 'inbasket', 'adminpanel', 'recordmanagement', 'fileintake'];

  const getLocalStorageDataFunc = async () => {
    try {
      const fetchedLocalStorageData = FetchLocalStorageDataByPath('system_config', 'features') ?? [];
      (await fetchedLocalStorageData.length) > 0 &&
        fetchedLocalStorageData.map((values) => {
          let newKey = values.title.toLowerCase().replace(/\s/g, '');
          if (
            visibilityRoutes.map((item) => {
              return item === newKey;
            })
          ) {
            setisFeatureActive((prev) => ({
              ...prev,
              [newKey]: values.value,
            }));
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getLocalStorageDataFunc();

    EventEmitter.on('LocalStorageUpdated', getLocalStorageDataFunc);

    return () => {
      EventEmitter.off('LocalStorageUpdated', getLocalStorageDataFunc);
    };
  }, []);

  const recordMgmtRoutes = ['fileplan', 'filecode', 'holds', 'transfer', 'manage'];

  const [userPermissions, setUserPermissions] = useState({});
  const onSelectLink = (val) => {
    setPopupVal(false);
    isLinkSelected(val);
  };
  const navigateSelectLink = (val) => {
    navigateTo(`/${val}`);
  };

  const location = useLocation();

  useEffect(() => {
    if (window.location.pathname.split('/')[window.location.pathname.split('/').length - 1] !== window.sessionStorage.getItem('BUOW_id')) {
      if (window.sessionStorage.getItem('lock_id') !== 'null' && window.sessionStorage.getItem('lock_id') !== null) {
        buowLockLooper(window.sessionStorage.getItem('lock_id'), false);
        window.sessionStorage.setItem('lock_id', null);
        window.sessionStorage.setItem('BUOW_id', null);
      }
    }
  });
  useEffect(() => {
    async function data() {
      await findPermissions();
    }
    data();
    isLinkSelected(
      window.location.pathname.length > 1
        ? window.location.pathname.split('/')[1]
        : window.location.pathname
    );
  }, [location]);

  const handleLeave = () => setPopupVal(false);

  const handleHover = () => setPopupVal(true);
  const findPermissions = async () => {
    try {
      const storedPermissions = JSON.parse(sessionStorage.getItem('permissions') || '[]');

      const userPermissions = storedPermissions.reduce((acc, perm) => {
        acc[perm] = true;
        return acc;
      }, {});

      setUserPermissions(userPermissions);
    } catch (error) {
      console.error('Error processing permissions', error);
    }
  };
  return (
    <>
      {/* navbar Start */}
      <nav className="navBarcontainer">
        <div className="nav_active">
          {userPermissions['My_In_Basket'] === true && isFeatureActive?.inbasket === true && selectedLink !== 'buow' && (
            <button
              className={selectedLink === 'inbasketpage' || selectedLink === '/' ? 'abcLink1 thinLine' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('inbasketpage');
                navigateSelectLink('inbasketpage');
              }}
              aria-label="Home page"
            >
              {selectedLink === 'inbasketpage' || selectedLink === '/' ? (
                <img src={houseWhite} alt="Go to in-basket page" className="scan_base_icon Categories" style={{ width: '19.13px', height: '17.5px' }} />
              ) : (
                <img src={houseGrey} alt="Go back to in-basket page" className="scan_base_icon Categories" style={{ width: '19.13px', height: '17.5px' }} />
              )}
            </button>
          )}

          {selectedLink === 'buow' && (
            <button
              className={selectedLink === 'buow' ? 'abcLink1 thinLine' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink(selectedLink === 'buow' ? 'inbasketpage' : 'buow');
                navigateSelectLink(selectedLink === 'buow' ? 'inbasketpage' : 'buow');
              }}
              aria-label="Navigate to Home Page"
            >
              <img
                src={selectedLink === 'buow' ? buowIcon : houseGrey}
                alt={selectedLink === 'buow' ? 'Access Buow Page' : 'Go back to in-basket page'}
                className="scan_base_icon"
                style={selectedLink !== 'buow' ? { width: '19.13px', height: '17.5px' } : {}}
              />
            </button>
          )}

          {isFeatureActive?.fileintake === true && userPermissions['Scan_On_Demand_Page'] && (
            <button
              className={selectedLink === 'scan' ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('scan');
                navigateSelectLink('scan');

              }}
              aria-label="File Intake Page"
            >
              {selectedLink === 'scan' ? (
                <img src={scanIconWhite} alt="File-intake page" className="scan_base_icon" />
              ) : (
                <img src={scanIcon} alt="Go to File-intake page" className="scan_base_icon" />
              )}
            </button>
          )}

          {isFeatureActive?.search === true && userPermissions['Search_Page'] === true && (
            <button
              className={selectedLink === 'search' ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('search');
                navigateSelectLink('search');
              }}
              aria-label="Search Page"
            >
              {selectedLink === 'search' ? (
                <img src={magnifyingGlassWhite} alt="Search page" className="scan_base_icon Categories" style={{ width: '17.01px', height: '17.5px' }} />
              ) : (
                <img src={magnifyingGlassGrey} alt="Go to Search page" className="scan_base_icon Categories" style={{ width: '17.01px', height: '17.5px' }} />
              )}
            </button>
          )}

          {isFeatureActive?.recordmanagement === true && userPermissions['Record_Management'] === true && (
            <Link
              to={'fileplan'}
              className={recordMgmtRoutes.includes(selectedLink) ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => onSelectLink('fileplan')}
              onMouseEnter={handleHover}
              onMouseLeave={handleLeave}
              onMouseOver={handleHover}
              onFocus={handleHover}
              onBlur={handleLeave}
              onKeyDown={(e) => {
                console.log(e.key, 'e.key');
                if (e.key === 'ArrowRight') {
                  e.preventDefault();
                  handleHover();

                  setTimeout(() => {
                    const firstItem = document.querySelector('.dropdownList li');
                    firstItem?.focus();
                  }, 100);
                }

                if (e.key === 'Escape') {
                  handleLeave();
                }
              }}
              aria-haspopup="true"
              aria-expanded={showPopup}
              style={{ marginBottom: '0.6rem' }}
            >
              <div>
                <img src={recordMgmtRoutes.includes(selectedLink) ? recordIconWhite : recordIcon} alt="Record management" className="base_icon" />

                {showPopup && <DropdownList selectedLink={selectedLink} onSelectLink={onSelectLink} userPermissions={userPermissions} navigateSelectLink={navigateSelectLink} />}
              </div>
            </Link>
          )}

          {isFeatureActive?.dashboard === true && userPermissions['View_Dashboard'] === true && (
            <button
              className={selectedLink === 'dashboard' ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('dashboard');
                navigateSelectLink('dashboard');
              }}
              aria-label="Dashboard"
            >
              {selectedLink === 'dashboard' ? (
                <img src={dashboardIconWhite} alt="Dashboard" className="base_icon" />
              ) : (
                <img src={dashboardIcon} alt="Go to Dashboard" className="base_icon" />
              )}
            </button>
          )}

          {((userPermissions['Administrator_Panel'] === true &&
            userRole &&
            userRole.length > 0 &&
            (userRole.includes('Admin') || userRole.includes('Application Administrator') || userRole.includes('Redaction Admin'))) ||
            (userPermissions['Administrator_Panel'] === true &&
              isFeatureActive?.adminpanel === true &&
              userRole &&
              userRole.length > 0 &&
              (userRole.includes('Admin') || userRole.includes('Application Administrator') || userRole.includes('Redaction Admin'))) ||
            userPermissions['Administrator_Panel'] === true) && (
              <button
                className={adminPanelRoutes.includes(selectedLink) ? 'abcLink1' : 'navLink style_NavPill'}
                onClick={() => {
                  onSelectLink('admin');
                  navigateSelectLink('admin');
                }}
                aria-label="Admin Panel"
              >
                <img src={adminPanelRoutes.includes(selectedLink) ? AdministratorIconWhite : Administrator} alt="Navigate to Admin Panel" className="base_icon" />
              </button>
            )}
        </div>
      </nav>
    </>
  );
};

const DropdownList = (props) => {
  const itemsRef = useRef([]);

  const items = [
    props.userPermissions['Record_Schedule'] && {
      label: 'Create Retention Instruction',
      path: 'fileplan',
      key: 'fileplan',
    },
    props.userPermissions['File_Management'] && {
      label: 'Manage Record Schedule',
      path: 'filecode',
      key: 'filecode',
    },
    props.userPermissions['Hold_Management'] && {
      label: 'Manage Holds',
      path: 'holds',
      key: 'holds',
    },
    props.userPermissions['Transfer_Management'] && {
      label: 'Manage Transfers',
      path: 'transfer',
      key: 'transfer',
    },
    props.userPermissions['Disposition_Management'] && {
      label: 'Manage Disposition',
      path: 'manage',
      key: 'manage',
    },
  ].filter(Boolean);

  const handleKeyDown = (e, index, key) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = (index + 1) % items.length;
      itemsRef.current[next]?.focus();
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = (index - 1 + items.length) % items.length;
      itemsRef.current[prev]?.focus();
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      props.onSelectLink(key);
      props.navigateSelectLink(key);
    }
  };

  return (
    <div className="dropdownList">
      {items.map((item, index) => (
        <Link key={item.key} to={item.path} onClick={() => props.onSelectLink(item.key)}>
          <li
            ref={(el) => (itemsRef.current[index] = el)}
            tabIndex={0}
            className={props.selectedLink === item.key ? 'selectedLink' : ''}
            onKeyDown={(e) => handleKeyDown(e, index, item.key)}
          >
            {item.label}
          </li>
        </Link>
      ))}
    </div>
  );
};

export default SideNavBar;
